import { Injectable } from '@angular/core';
import { IDRFilter, IColumnSetting } from '@app/discoverer/core';

@Injectable({ providedIn: 'root' })
export class FilterCreationService {

    public createFilter(fieldName: string, value: any, currentTabCols: IColumnSetting[]): IDRFilter {

        const field = currentTabCols?.find(x => x.fieldName === fieldName);
        const isDate =
            field &&
            (field.dataType === 'date' ||
                field.dataType === 'timestamp' ||
                field.dataType === 'timestamptz');

        if (isDate) {
            const startDate = new Date(value.startDate);
            startDate.setHours(0, 0, 0, 0);
            const endDate = new Date(value.endDate);
            endDate.setHours(23, 59, 59, 999);
            const dateFilterKey = `[${startDate.toISOString()} TO ${endDate.toISOString()}]`;
            return { type: 'facet', fields: [fieldName], expression: [dateFilterKey] };
        }

        return { type: 'facet', fields: [fieldName], expression: [value] };
    }
}